<template>
    <div class="overflow-x-hidden">

        <section
            class="subjects-section text-center grid flex flex-wrap justify-content-center align-items-center py-2 px-4 md:px-6">

            <div v-if="bgUrl" class="background-image"
                :style="{ backgroundImage: `url('${bgUrl}')`, filter: 'brightness(0.6)', zIndex: 0 }">
            </div>
            <div class="container relative z-1 text-center px-4 md:px-6 md:py-2 my-4" >
                <span class="badge mb-3">Subject Explorer</span>
                <h2 class="LandingPage-Title text-white mb-3">Subjects We Have</h2>
                <p class="text-white Paragraph-Regular mx-auto mb-6">
                    Find expert tutors for all major subjects taught in Sri Lankan schools. From primary grades to
                    Advanced Level, we've got you covered.
                </p>

                <div class="grid justify-content-center gap-3 md:gap-5 py-6">
                    <div v-for="(subject, i) in subjects" :key="i" class="col-12 md:col-6 lg:col-4 xl:col-3">
                        <div class="p-4 border-round-lg shadow-2 subject-card text-left h-full"  v-animateonscroll="{ enterClass: 'animate-zoom-in'}">
                            <div class="flex flex-wrap justify-content-between align-items-start ">
                                <h4 class="H6-Medium text-white mb-0 mt-0">{{ subject.name }}</h4>
                                <span v-if="subject.popular"
                                    class="Caption bg-indigo-400 text-white px-2 py-1 border-round-2xl">Popular</span>
                            </div>
                            <p class="mb-2 Caption text-white mt-1 mb-4">{{ subject.description }}</p>
                            <p class="Paragraph-Medium mb-3 text-white">{{ subject.grade }}</p>

                            <div class="flex align-items-center gap-3 text-sm">
                                <span class="text-white"><i class="pi pi-users mr-2 Label text-white"></i>120+
                                    Tutors</span>
                                <span class="text-white border-round-3xl border-1 border-white px-2">
                                    <i class="pi pi-star-fill mr-1 Label"></i>4.9
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="mt-6">
                    <Button label="Browse all subjects" icon="pi pi-search" class="community-button"
                        @click="TutorMatch" />
                </div>
            </div>
        </section>
    </div>
</template>
<script setup>
import Button from 'primevue/button';
import { useRouter } from "vue-router";
import { usePublicUrl } from "@/utils/getPublicUrl"

const router = useRouter();
const bgUrl = usePublicUrl("public/subjects-cover-image.jpg");

const subjects = [
    { name: "Mathematics", description: "Algebra, Calculus, Statistics & More", grade: "Grade 6–A/L", popular: true },
    { name: "Science", description: "Physics, Chemistry, Biology", grade: "Grade 6–A/L", popular: true },
    { name: "English", description: "Language, Literature & Communication", grade: "Grade 1–A/L", popular: true },
    { name: "Sinhala", description: "Language & Literature", grade: "Grade 1–A/L" },
    { name: "Tamil", description: "Language & Literature", grade: "Grade 6–11" },
    { name: "ICT", description: "Programming, Web Dev & More", grade: "Grade 6–A/L", popular: true },
    { name: "Art & Design", description: "Creative Arts & Visual Design", grade: "All ages" },
    { name: "Music", description: "Instruments, Theory & Performance", grade: "All ages" },
    { name: "ICT", description: "Programming, Web Dev & More", grade: "Grade 6–A/L", popular: true },
];

const TutorMatch = () => {
    router.push('/matchTutor')
}
</script>
<style scoped>
.subjects-section {
    position: relative;
}

.background-image {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.subject-card {
    background: rgba(26, 109, 115, 0.7);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
    box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
    border: 1px solid white !important;
    /* Remove backdrop-filter as it won't work on the element itself */
}

.subject-card:hover {
    transform: translateY(-6px);
    box-shadow: 0px 10px 20px 0px rgba(0, 0, 0, 0.25);
}

.community-button {
    background-color: #FF802E;
    color: white;
}

::v-deep(.community-button:hover) {
    background-color: #FF802E !important;
    border-color: #FF802E !important;
    color: white;
}

::v-deep(.community-button:active,
    .community-button:focus) {
    background-color: #FF802E !important;
    border-color: #FF802E !important;
}

.pi-star-fill {
    color: #CCB800;
}
</style>